"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _NotificationEnablePanelWrapper = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/NotificationEnablePanelWrapper"));

var _validation = require("@insided/shared/utils/validation");

var _biConnectorUtils = require("@insided/deprecated-control/integrations/components/bi-tools-connector/biConnectorUtils");

var _NotificationInputField = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/NotificationInputField"));

var _HeaderTable = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/HeaderTable"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var primaryModel = [{
  header: 'Key',
  accessor: 'key',
  size: 'small'
}, {
  header: 'Value',
  accessor: 'value',
  size: 'small'
}, {
  header: '',
  accessor: 'deletebtn',
  size: 'small'
}];

var EnableForHttpOrHttps = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EnableForHttpOrHttps, _Component);

  var _super = _createSuper(EnableForHttpOrHttps);

  function EnableForHttpOrHttps() {
    var _this;

    (0, _classCallCheck2.default)(this, EnableForHttpOrHttps);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "labelRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "urlRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      rows: [{
        key: '',
        value: ''
      }],
      error: {
        label: '',
        url: '',
        headers: ''
      },
      canSaveData: false,
      label: '',
      url: '',
      canBeEnabled: false,
      isEnabled: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIsEnabled", function (isEnabled) {
      _this.setState({
        isEnabled: isEnabled
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addRow", function () {
      if (_this.state.rows.length < 10) {
        _this.setState(function (prevState) {
          return {
            rows: [].concat((0, _toConsumableArray2.default)(prevState.rows), [{
              key: '',
              value: ''
            }])
          };
        });

        return;
      }

      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          error: _objectSpread(_objectSpread({}, prevState.error), {}, {
            headers: 'Maximum 10 rows allowed'
          }),
          canSaveData: false
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deleteRow", function (index) {
      if (_this.state.rows.length === 1) return;

      _this.setState(function (prevState) {
        var updatedRows = prevState.rows.filter(function (row, i) {
          return i !== index;
        });
        var headersError = '';

        var _iterator = _createForOfIteratorHelper(updatedRows),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var row = _step.value;

            if ((!row.key || !row.value) && (row.key !== '' || row.value !== '')) {
              headersError = "".concat(!row.key ? 'Key cannot be empty. ' : '').concat(!row.value ? 'Value cannot be empty.' : '');
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var updatedErrors = _objectSpread(_objectSpread({}, prevState.error), {}, {
          headers: headersError
        });

        return _objectSpread(_objectSpread({}, prevState), {}, {
          rows: updatedRows,
          error: updatedErrors,
          canSaveData: headersError === ''
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateRows", function (index, field, value) {
      _this.setState(function (prevState) {
        var updatedRows = [].concat((0, _toConsumableArray2.default)(prevState.rows.slice(0, index)), [_objectSpread(_objectSpread({}, prevState.rows[index]), {}, (0, _defineProperty2.default)({}, field, value))], (0, _toConsumableArray2.default)(prevState.rows.slice(index + 1, prevState.rows.length)));
        var updatedRow = updatedRows[index];
        var hasError = (!updatedRow.key || !updatedRow.value) && (updatedRow.key !== '' || updatedRow.value !== '');
        var headersError = '';

        if (updatedRows.length === 10) {
          headersError = 'Maximum 10 rows allowed';
        } else if (!updatedRow.key || !updatedRow.value) {
          headersError = "".concat(!updatedRow.key ? 'Key cannot be empty. ' : '').concat(!updatedRow.value ? 'Value cannot be empty.' : '');
        }

        var updatedErrors = _objectSpread(_objectSpread({}, prevState.error), {}, {
          headers: hasError ? headersError : ''
        });

        return _objectSpread(_objectSpread({}, prevState), {}, {
          rows: updatedRows,
          error: updatedErrors,
          canSaveData: updatedErrors.headers === ''
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addToTableData", function (e, index, field) {
      if (field === 'key') _this.updateRows(index, 'key', e.target.value.trim());else if (field === 'value') _this.updateRows(index, 'value', e.target.value.trim());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "convert", function () {
      var data = {};
      var indexToBeDeleted = [];

      _this.state.rows.forEach(function (row, currentIndex) {
        if (row.key !== '' && row.value !== '') data[row.key] = row.value;else indexToBeDeleted.unshift(currentIndex);
      });

      indexToBeDeleted.forEach(function (val) {
        return _this.deleteRow(val);
      });
      return data;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clearFields", function () {
      _this.setState({
        label: '',
        url: '',
        canSaveData: false,
        rows: [{
          key: '',
          value: ''
        }]
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRows", function () {
      return _this.state.rows.map(function (row, index) {
        return {
          key: (0, _preact.h)("input", {
            type: "text",
            placeholder: "API KEY",
            className: "notification-input-no-border table-input",
            value: row.key,
            onChange: function onChange(e) {
              _this.addToTableData(e, index, 'key');
            },
            disabled: _this.props.requestState.type === 'info'
          }),
          value: (0, _preact.h)("input", {
            type: "text",
            placeholder: "Label",
            className: "notification-input-no-border table-input",
            value: row.value,
            onChange: function onChange(e) {
              _this.addToTableData(e, index, 'value');
            },
            disabled: _this.props.requestState.type === 'info'
          }),
          deletebtn: (0, _preact.h)(_Button.default, {
            size: "small",
            icon: "trashOutlined",
            onClick: function onClick() {
              _this.deleteRow(index);
            },
            className: "button-border-none show-hide-btn-no-outline",
            oldStyle: true,
            disabled: _this.props.requestState.type === 'info'
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRowValidation", function () {
      var _iterator2 = _createForOfIteratorHelper(_this.state.rows),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var row = _step2.value;

          if ((!row.key || !row.value) && (row.key !== '' || row.value !== '')) {
            _this.setState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                canSaveData: false
              });
            });

            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleLabelChange", function (value) {
      if (value !== '') {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            label: value,
            canSaveData: prevState.url !== '' && value !== '' && (0, _validation.isUrlValid)(prevState.url),
            canBeEnabled: prevState.url !== '' && value !== '',
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              label: ''
            })
          });
        });
      } else {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            canSaveData: false,
            label: '',
            canBeEnabled: false,
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              label: 'Label cannot be empty'
            })
          });
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleURLChange", function (value) {
      if (value !== '') {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            url: value,
            canSaveData: prevState.label !== '' && value !== '' && (0, _validation.isUrlValid)(value),
            canBeEnabled: prevState.label !== '' && value !== '',
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              url: ''
            })
          });
        });
      } else {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            canSaveData: false,
            url: '',
            canBeEnabled: false,
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              url: 'URL cannot be empty'
            })
          });
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleURLBlur", function () {
      if (_this.state.url !== '' && !(0, _validation.isUrlValid)(_this.state.url)) {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            error: _objectSpread(_objectSpread({}, prevState.error), {}, {
              url: 'Invalid URL'
            }),
            canSaveData: false
          });
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(EnableForHttpOrHttps, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.props.targets.find(function (target) {
        if (target.type === 'webhook') {
          _this2.setState(function (prevState) {
            return {
              label: target.label,
              url: target.config.endpoint,
              canSaveData: true,
              canBeEnabled: !!(target.label && target.config.endpoint),
              isEnabled: target.active,
              rows: target.config.headers && Object.keys(target.config.headers).length > 0 ? Object.entries(target.config.headers).map(function (_ref) {
                var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                return {
                  key: key,
                  value: value
                };
              }) : prevState.rows
            };
          });

          return true;
        }

        return false;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          label = _this$state.label,
          url = _this$state.url,
          error = _this$state.error;
      var requestState = this.props.requestState;
      var fields = [{
        label: 'Label',
        required: true,
        element: (0, _preact.h)(_NotificationInputField.default, {
          type: "text",
          value: label,
          error: error.label,
          placeholder: "Label",
          disabled: requestState.type === 'info',
          onInputChange: this.handleLabelChange,
          onBlur: this.handleRowValidation
        })
      }, {
        label: 'URL',
        required: true,
        element: (0, _preact.h)(_NotificationInputField.default, {
          type: "url",
          value: url,
          error: error.url,
          placeholder: "https://example.com",
          disabled: requestState.type === 'info',
          onInputChange: this.handleURLChange,
          onBlur: this.handleURLBlur
        })
      }, {
        label: 'Header',
        required: false,
        isTable: true,
        rows: this.getRows(),
        model: primaryModel,
        element: (0, _preact.h)(_HeaderTable.default, {
          rows: this.getRows(),
          model: primaryModel,
          error: error.headers,
          disabled: requestState.type === 'info',
          onAddRow: this.addRow
        })
      }];
      return (0, _preact.h)(_NotificationEnablePanelWrapper.default, {
        title: "Enable for HTTP/HTTPS",
        header: "Input Label and Endpoint URL and Values to enable notifications for HTTP/HTTPS",
        inputFields: fields,
        canSaveData: this.state.canSaveData,
        clearFields: this.clearFields,
        getData: function getData() {
          return (0, _biConnectorUtils.getHttpNotificationData)(_this3.state, _this3.props);
        },
        notificationType: "webhook",
        canBeEnabled: this.state.canBeEnabled,
        requestState: this.props.requestState,
        setRequestState: this.props.setRequestState,
        isEnabled: this.state.isEnabled,
        setIsEnabled: this.setIsEnabled
      });
    }
  }]);
  return EnableForHttpOrHttps;
}(_preact.Component);

var _default = EnableForHttpOrHttps;
exports.default = _default;